import { call, put } from 'redux-saga/effects';
import { setMakesCar, setModelsCar, setGenerationsCar, setMotorsCar } from '../../entities/cars';
import {
    requestGetMakesCar,
    requestGetModelsCar,
    requestGetGenerationsCar,
    requestGetMotorsCar,
} from '../requests/cars';

export function* handleGetMakesCar(_action) {
    try {
        const response = yield call(requestGetMakesCar);
        const { data } = response;
        yield put(setMakesCar({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetModelsCar(action) {
    try {
        const response = yield call(requestGetModelsCar, action.payload);
        const { data } = response;
        yield put(setModelsCar({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetGenerationsCar(action) {
    try {
        const response = yield call(requestGetGenerationsCar, action.payload);
        const { data } = response;
        yield put(setGenerationsCar({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetMotorsCar(action) {
    try {
        const response = yield call(requestGetMotorsCar, action.payload);
        const { data } = response;
        yield put(setMotorsCar({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

